import axiosInstance from "core/api/axiosInstance";

export const getGerenciaData = async (tipo, filtros = {}, { signal } = {}) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("No token provided");

  try {
    const { data } = await axiosInstance.get(`/api/dashboard/get-data/${tipo}`, {
      headers: { Authorization: `Bearer ${token}` },
      params: filtros,
      signal,
    });

    return data;
  } catch (error) {
    if (signal?.aborted) throw error;
    throw new Error(error.response?.data?.message || `Error al obtener datos de ${tipo}`);
  }
};
